import React from 'react';
import { connect } from 'react-redux';

import Dialog from 'material-ui/Dialog';
import Spinner from 'material-ui/CircularProgress';

import Button from '../../components/basic/Button';
import { uploadFile } from '../../services/Api';

const initialState = {
  uploading: false,
  uploaded: false,
  progress: 0,
  file: null,
  url: null,
  request: null
};

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  handleClose = () => {
    this.setState(initialState);
    const { onClose, modalId } = this.props;
    if (onClose) {
      onClose(modalId);
    }
  };

  handleDone = () => {
    const { url } = this.state;
    const { onUrlSet } = this.props;
    if (onUrlSet) {
      onUrlSet(url);
    }
    this.handleClose();
  };

  handleStartUpload = () => {
    const { file } = this.state;
    if (!file) {
      return;
    }
    const fileBlob = new Blob([file], { type: file.type });
    this.setState({ uploading: true });
    const req = uploadFile(fileBlob, this.props.auth.access_token);
    req
      .on('progress', e => {
        this.handleProgress(e.percent);
      })
      .then(res => {
        this.setState({
          uploading: false,
          progress: 100,
          url: res.body.payload.url
        });
      })
      .catch(() => {
        this.setState({
          uploading: false,
          error: true,
          progress: 0
        })
      });
    this.setState({ request: req });
  };

  handleCancelUpload = () => {
    const { request } = this.state;
    if (request) {
      request.abort();
      this.setState({
        request: null,
        uploading: false,
        progress: 0,
        url: null,
        error: false
      });
    }
  };

  handleProgress = progress => {
    this.setState({ progress });
  };

  handleChange = e => {
    this.setState({
      file: e.target.files[0],
      error: false
    });
  };

  render() {
    /**
     * No file:
     * CLOSE
     *
     * File
     * CLOSE | UPLOAD
     *
     * File uploading
     * CANCEL
     *
     * File uploaded
     * CANCEL | DONE
     */
    const { file, uploading, progress, error } = this.state;
    const actions = [];
    if (!file) {
      actions.push(<Button label="Close" onClick={this.handleClose} />);
    } else if (uploading) {
      actions.push(<Button label="Cancel" onClick={this.handleCancelUpload} />);
    } else if (progress === 100) {
      actions.push(<Button label="Cancel" onClick={this.handleClose} />);
      actions.push(<Button label="Done" primary raised onClick={this.handleDone} />);
    } else {
      actions.push(<Button label="Upload" primary raised onClick={this.handleStartUpload} />);
    }
    return (
      <Dialog
        actions={actions}
        modal={false}
        open={this.props.open}
        onRequestClose={this.handleClose}
        contentStyle={{ minWidth: '200px', maxWidth: '500px' }}
      >
        <p>
          Hey! Would you like to upload a file directly? If not, close this dialog and paste the URL into the field.
        </p>
        <div className="upload-btn-wrapper">
          <Button label="Choose a file" secondary />
          <input type="file" name="uploadedFile" onChange={this.handleChange} />
          <small>Or drop it here.</small>
        </div>
        <small>* Maximum allowed size is 10MB</small>
        {file && (
          <div className="upload-files-list">
            <div className="upload-file-name flex flex1">
              <div className="flex1">{file.name}</div>
              {uploading && <Spinner size={24} thickness={4} />}
              {error && <span className="text-danger">Upload error</span>}
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};
export default connect(mapStateToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/FileUploadModal.js